import {
  Icon,
  LinkButton,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@eluve/components';

interface GoToPatientButtonProps {
  tenantId: string;
  patientId: string;
}

export const GoToPatientButton: React.FC<GoToPatientButtonProps> = ({
  tenantId,
  patientId,
}) => (
  <Tooltip>
    <TooltipTrigger asChild>
      <LinkButton
        className="h-auto w-10 shrink-0 rounded-lg px-0"
        variant="outline"
        to={`/organizations/${tenantId}/patients/${patientId}`}
      >
        <Icon name="ChevronRight" size="auto" />
      </LinkButton>
    </TooltipTrigger>
    <TooltipContent>Go to patient</TooltipContent>
  </Tooltip>
);
